import { formatCurrency } from "@/lib/format";

export function toTitle(s) {
  if (!s) return "";
  return s.replace(/\w\S*/g, (w) => w[0].toUpperCase() + w.slice(1).toLowerCase());
}

export function parseDateMs(s) {
  if (!s) return Number.POSITIVE_INFINITY;
  const t = Date.parse(s);
  return Number.isNaN(t) ? Number.POSITIVE_INFINITY : t;
}

export function EmptyChart() {
  return (
    <div className="h-[280px] flex items-center justify-center text-sm text-slate-400">
      No data matches the current filter.
    </div>
  );
}

export function renderPieLabel({ cx, cy, midAngle, outerRadius, percent, value }) {
  if (!percent || percent < 0.005) return null;
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 24;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const anchor = x > cx ? "start" : "end";
  return (
    <g>
      <text x={x} y={y - 4} textAnchor={anchor} fill="#1A1C1E" fontSize="12" fontWeight="700">
        {(percent * 100).toFixed(1)}%
      </text>
      <text x={x} y={y + 11} textAnchor={anchor} fill="#5E6A78" fontSize="10" fontWeight="500">
        {formatCurrency(value, { compact: true })}
      </text>
    </g>
  );
}

export function renderBudgetLabel({ x, y, width, value }) {
  if (value == null) return null;
  const cx = x + width / 2;
  return (
    <g>
      <text x={cx} y={y - 22} textAnchor="middle" fontSize="10" fontWeight="700" fill="#1A1C1E">
        {formatCurrency(value, { compact: true })}
      </text>
      <text x={cx} y={y - 8} textAnchor="middle" fontSize="10" fontWeight="600" fill="#5E6A78">
        100%
      </text>
    </g>
  );
}

export function renderSpentLabel(data) {
  return function SpentBarLabel({ x, y, width, value, index }) {
    if (value == null) return null;
    const cx = x + width / 2;
    const budget = data?.[index]?.budget || 0;
    const pct = budget > 0 ? `${((value / budget) * 100).toFixed(0)}%` : "—";
    return (
      <g>
        <text x={cx} y={y - 22} textAnchor="middle" fontSize="10" fontWeight="700" fill="#1A1C1E">
          {formatCurrency(value, { compact: true })}
        </text>
        <text x={cx} y={y - 8} textAnchor="middle" fontSize="10" fontWeight="700" fill="#327de3">
          {pct}
        </text>
      </g>
    );
  };
}
